
import DrugService from '@/services/drug.service'
import LocationService from '@/services/epharmacylocation.service'
import ShowMessage from '@/components/messages/ShowMessage.js'

export default {
    mixins: [ShowMessage],
    data() {
        return {
            LocList:[],
            DrugTypeList:[],
            DrugList:[],
            params: {
                DrugType: '',
                LocList:'',
                DrugList:''
            },
        }},
    methods: {

        getLocationsFilter() {
          const params = {
            SearchCriteria: '',
            FilterByEmployee:true
          } 
          return LocationService.getAll(params)
            .then((response) => {
              if (response.status == '200' && response.data && response.data.length > 0) {
                this.LocList = response.data;
                return this.LocList; // Return the array
              }
              return []; // Return empty array if no data
            })
            .catch(error => {
              if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.RetrieveInformation'), "error");
              } else {
                this.showMessage(this.$tc('Msg.Error'), error, "error");
              }
              return []; // Return empty array on error
            });

        },

        getDrugTypeFilter() {
          return DrugService.getDrugType()
            .then((response) => {
              if (response.status == '200' && response.data && response.data.length > 0) {
                this.DrugTypeList = response.data;
                return this.DrugTypeList; // Return the array
              }
              return []; // Return empty array if no data
            })
            .catch(error => {
              if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.RetrieveInformation'), "error");
              } else {
                this.showMessage(this.$tc('Msg.Error'), error, "error");
              }
              return []; // Return empty array on error
            });

        },

        getDrugsFilter() { 
          const params = {
            SearchCriteria: '',
          }
          return DrugService.getAll(params)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.DrugList = response.data;
              return this.DrugList
            }
            return []; // Return empty array if no data
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
            return []; // Return empty array if no data
          });
        },
        
        ChangeDrugType(values) {
          var drugType = '';
          if (values && values.length > 0) {
              drugType = values.map(x => x.code).join(',');
          }
          this.params.DrugType = drugType; 
          return this.params.DrugType
        },

        ChangeDrugs(values){
          var drugs = '';
          if (values && values.length > 0) {
              drugs = values.map(x => x.drugCode).join(',');
          }
          this.params.DrugList = drugs;
          return this.params.DrugList; 
        },

        ChangeLocation(values){
          var locations = '';
          if (values && values.length > 0) {
              locations = values.map(x => x.code).join(',');
          }
          this.params.LocList = locations;
          return this.params.LocList; 
        },
    }
}